<template>
  <div class="BSStart" v-loading="loading">
    <materialSelect v-if="showMater" @getNoticeList="changeOthers" />
    <topbar title="竞价中" @changeTimeFun="changeTimeFun" :num="num" />
    <template v-if="list.length || loading">
      <div class="list">
        <startCard
          @getNoticeList="getNoticeList"
          :data="item"
          v-for="item in list"
          :key="item.id"
        />
      </div>
    </template>
    <template v-else>
      <empty />
    </template>
    <template v-if="showMater">
      <el-pagination
        background
        layout="prev, pager, next,total,jumper"
        :total="num"
        :page-size="12"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
      >
      </el-pagination>
    </template>
  </div>
</template>

<script>
import topbar from './components/topbar.vue'
import materialSelect from './components/materialSelect.vue'
import empty from './components/empty.vue'
import startCard from './components/startCard.vue'
import { debouce } from '@/utils/common'
import config from '@/config'

export default {
  name: 'BSStart',
  components: {
    topbar,
    materialSelect,
    empty,
    startCard
  },
  computed: {
    showMater() {
      return this.$route.path.indexOf('biddingSpecial/index') < 0
    }
  },
  data() {
    return {
      num: 0,
      param: {
        bidSort: 'bidEndSort',
        biddingCodeCode: 1,
        bidSortType: 'desc',
        compCode: '',
        pageNum: 1,
        pageSize: 12,
        title: '',
        code: '',
        mateIds: ''
      },
      list: [],
      loading: false
    }
  },
  mounted() {
    this.loading = true
    const { compCode } = this.$route.query
    this.param.compCode = compCode
    this.getNoticeList()
  },
  methods: {
    // 时间排序
    changeTimeFun(type) {
      console.log(type)
      this.param.bidSortType = type
      this.getNoticeList()
    },
    // 表单筛选
    changeOthers({ mateIds = '', title = '', code = '' }) {
      this.param.mateIds = mateIds
      this.param.title = title
      this.param.code = code
      this.getNoticeList()
    },
    // 获取数据
    getNoticeList: debouce(function() {
      if (!this.showMater) {
        this.param.pageSize = 8
      }
      this.loading = true
      this.$api.notice.getNoticeList(this.param).then(data => {
        // console.log(data)
        this.num = data.total || 0
        if (data && data.length != 0) {
          this.list = data.data.map(item => {
            item.imageUrl = config.STATIC_URL + item.imageUrl
            return item
          })
        } else {
          this.list = []
        }
        this.loading = false
      })
    }, 500),
    // 分页
    handleCurrentChange(val) {
      this.param.pageNum = val
      this.getNoticeList()
    }
  }
}
</script>

<style lang="less" scoped>
.BSStart {
  border-bottom: 20px solid #f5f5f5;
  max-width: 1200px;
  margin: 20px auto;
  .list {
    display: flex;
    flex-wrap: wrap;
  }
  .el-pagination button {
    padding: 5px 10px;
  }
}
</style>
